const doc = [({"da":({"models":({"proposal_vote":({"blank_vote":"Blank stemme", "no":"Nej", "yes":"Ja"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;